import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as WarningIcon } from '../../../../../assets/images/warningIcon.svg';
import Button from '../../../../../components/shared/Button/Button';
import Modal from '../../../../../components/shared/Modal/Modal.jsx';
import { IsMobile } from '../../../../../helpers/IsMobile';

import styles from './HeadersModal.module.scss';

const HeadersModal = ({ showModal, toggleModal, handleContinue, data, TEMPLATE_URL }) => {
  const { t } = useTranslation('common');
  const isMobile = IsMobile();
  return (
    <Modal
      show={showModal}
      onHide={toggleModal}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      fullscreen={isMobile}
    >
      <Modal.CustomHeader closeButton>
        <Modal.Title id="contained-modal-title-vcenter">{t('modals.areYouSure')}</Modal.Title>
      </Modal.CustomHeader>
      <Modal.Body>
        <div className={styles.content}>
          <WarningIcon />
          <div>
            <p className={styles.text}>{t('csvImport.couldntIdentifyHeaders')}</p>
            <p className={styles.text}>
              {t('csvImport.usingTemplate')}&nbsp;
              <a href={TEMPLATE_URL} download className={styles.downloadLink}>
                {t('csvImport.templateDoc')}
              </a>
              ?
            </p>
            <p className={styles.heading}>{t('csvImport.headersDidntMatch')}</p>
            {data.map((header) => (
              <p className={styles.header} key={header}>
                {header}
              </p>
            ))}
          </div>
        </div>
      </Modal.Body>
      <Modal.CustomFooter>
        <div className={styles.btnsCont}>
          <Button variant="outline-primary" onClick={handleContinue} className={styles.yesNoBtn}>
            {t('csvImport.continueAnyway')}
          </Button>
          <Button variant="primary" onClick={toggleModal} className={styles.yesNoBtn}>
            {t('csvImport.cancelDownloadTemplate')}
          </Button>
        </div>
      </Modal.CustomFooter>
    </Modal>
  );
};

export default HeadersModal;
